import React from 'react';
import { Link } from 'react-router-dom';
import './PageShell.css';

interface Props {
  title: string;
  subtitle: string;
  children: React.ReactNode;
}

// Shared chrome for every "appendix" page (Data, Model Explanation, Upgrade Plan) —
// a back link plus a plain-language title/subtitle, so each page only has to
// bring its own body content.
export default function PageShell({ title, subtitle, children }: Props) {
  return (
    <div className="page">
      <div className="page__header">
        <Link to="/" className="page__back">
          ← Back to Watch
        </Link>
        <h1 className="page__title">{title}</h1>
        <p className="page__subtitle">{subtitle}</p>
      </div>
      <div className="page__body">{children}</div>
    </div>
  );
}
